export const translation = {
  AND: 'AND',
  OR: 'OR',
  PKCS11Tokens: 'PKCS#11 Tokens',
  a11y: {
    accessibilityStatement: {
      aIcon: 'WAI A WCAG 2.1 icon',
      aaIcon: 'WAI AA WCAG 2.1 icon',
    },
    common: {
      dashboard: {
        navigateToIssueForReport: 'View issue {{issueNumber}} {{issueName}} in report {{reportId}} {{reportName}}',
      },
      filters: {
        addFilter: 'Add filter',
        updateFilter: 'Save filter',
      },
    },
    comparison: {
      collapseButton: 'Collapse layout',
      expandButton: 'Expand layout',
      instancesChart: 'Report instances pie chart',
      issuesChart: 'Report issues pie chart',
    },
    dialogs: {
      dialogCloseButton: 'Close dialog',
      fileUploadError: 'Failed to upload',
      fileUploadProgress: 'Uploading file',
      fileUploadRemove: 'Remove file',
    },
    exceptions: {
      actions: 'Delete exception',
    },
    footer: {
      logo: 'SandboxAQ icon',
    },
    general: {
      actionDropDown: 'Action dropdown menu',
      knowledgeBase: 'View Knowledge Base article for {{topic}}',
      loading: 'Loading...',
      prefixOpensInNewTab: '{{prefix}} (opens in a new tab)',
    },
    integrations: {
      configureLabel: 'Configure {{integration}} integration',
      settingsLabel: 'View {{integration}} settings',
    },
    jiraIntegrations: {
      copyIconLabel: 'Copy to Clipboard',
      jiraSettingsTabsLabel: 'Configure Jira Integration Steps',
      stepProgressLabel: 'Step {{step}} of {{totalSteps}}',
    },
    login: {
      mainLogo: 'AQtive Guard logo',
      ssoIcon: 'single sign-on icon',
    },
    navigation: {
      breadcrumbs: 'Breadcrumbs',
      docs: 'AQtive Guard documentation',
      mainNavigation: 'Main navigation',
    },
    organization: {
      certificate: {
        matchedCertificates: {
          certificateIdLabel: 'View certificate {{certId}} in report {{reportId}} {{reportName}}',
          projectLabel: 'View project {{projectId}} {{projectName}}',
          reportLabel: 'View report {{reportId}} {{reportName}}',
        },
        publicKeyLabel: 'View organization key {{keyId}}',
      },
      certificates: {
        certificateIdLabel: 'View certificate {{certId}}',
        publicKeyLabel: 'View organization key {{keyId}}',
      },
      dashboard: {
        chartTitle: 'Chart {{chartName}}',
        legendRowOff: 'Show overview {{overview}}',
        legendRowOn: 'Hide overview {{overview}}',
        navigateToIssueForProject: 'View issue {{issueNumber}} {{issueName}} in project {{projectId}} {{projectName}}',
        overviewChart: 'Instance summary pie chart, {{high}} high {{medium}} medium {{low}} low and {{passed}} passed instances',
        trendsChart: 'Instance summary bar chart, {{range}}',
      },
      key: {
        certificates: {
          certificateIdLabel: 'View certificate {{certId}}',
        },
        matchedKeys: {
          keyIdLabel: 'View key {{keyId}} in report {{reportId}} {{reportName}}',
          projectLabel: 'View project {{projectId}} {{projectName}}',
          reportLabel: 'View report {{reportId}} {{reportName}}',
        },
      },
      keys: {
        keyIdLabel: 'View organization key {{keyId}}',
      },
      profiles: {
        actions: 'Edit or delete profile',
        builtInProfileName: 'View details for {{profileType}} AQtive Guard profile {{profileName}}',
        preset: 'AQtive Guard profile',
        profileName: 'View details for {{profileType}} profile {{profileName}}',
      },
      projects: {
        actions: 'Edit or delete project',
        collapseIssueRow: 'Hide issue {{issueNumber}} {{issueName}}',
        collapseProjectRow: 'Hide issues for project {{projectId}} {{projectName}}',
        expandIssueRow: 'Show issue {{issueNumber}} {{issueName}}',
        expandProjectRow: 'Show issues for project {{projectId}} {{projectName}}',
        issueBarElement: '{{amount}} {{severity}} severity issues',
        issueBarElementNoWarning: '{{amount}} no warning issues',
        issueBarEmpty: 'The project has no issues',
        linkToProjectDashboard: 'View project {{projectId}} {{projectName}}',
        toggleIssueSeverityOff: 'Show {{severity}} severity issues',
        toggleIssueSeverityOn: 'Hide {{severity}} severity issues',
      },
      scans: {
        actions: 'Stop scan',
        collapseScanRow: 'Hide hosts for scan {{scanId}} {{scanName}}',
        expandScanRow: 'Show issues for scan {{scanId}} {{scanName}}',
      },
      users: {
        actions: 'Edit or delete user',
      },
    },
    profile: {
      compatibleTracerRule: 'Supported in {{traceType}} reports',
      fuzzerCategoryAccordion: 'Rules for category {{category}} in ruleset {{ruleset}}',
      incompatibleTracerRule: 'Not supported in {{traceType}} reports',
      ruleDisabled: 'The rule is disabled',
      ruleEnabled: 'The rule is enabled',
      ruleToggleStatus: 'Rule status',
      thresholds: {
        toggleCurrentValue: '{{threshold}} threshold, current value from {{from}} to {{to}} {{unit}}',
        toggleCurrentValueNotSet: '{{threshold}} threshold, current value not set',
      },
      tracerCategoryAccordion: 'Rules for category {{category}}',
    },
    project: {
      dashboard: {
        createNewExceptionLink: 'Link to a page where you can create a new exception',
        issueAccordion: 'Grouped issues by the severity {{severity}}',
      },
      integrations: {
        docs: {
          jiraFormIntegrationLabel: 'Learn more about Jira Form Integration',
          jiraIssueExportLabel: 'Learn more about Jira Issue Export',
        },
        notRunningLogo: 'AQtive Guard logo',
        taniumCompletedLogo: 'AQtive Guard logo with checkmark',
        taniumRunningLogo: 'Tanium retrieval in progress logo',
      },
      slots: {
        actions: 'Edit or delete slot',
        addNewTrace: 'Add a new trace in slot {{slotName}}',
        updateTags: 'Add or update tags for slot {{slotName}}',
      },
    },
    report: {
      certificates: {
        certificateIdLabel: 'View certificate {{certId}}',
        organizationCertificateLabel: 'View organization certificate {{certId}}',
        publicKeyIdLabel: 'View key {{keyId}}',
        venafiGuidLabel: 'Open certificate {{certId}} in Venafi',
      },
      ciphersuites: {
        chevronSelectedTooltip: 'Show handshakes that use ciphersuite {{ciphersuite}}',
        chevronSupportedTooltip: 'Show handshakes that support ciphersuite {{ciphersuite}}',
      },
      export: {
        configureJira: 'Configure Jira',
        csvIcon: 'CSV Icon',
        csvOptions: 'CSV Options',
        downloadCsv: 'Download CSV',
        downloadJson: 'Download JSON',
        exportType: 'Export type',
        jiraIcon: 'Jira Icon',
        jsonIcon: 'JSON Icon',
        printIcon: 'Print Icon',
        printOptions: 'Print Options',
        serviceNowIcon: 'ServiceNow Icon',
      },
      handshakes: {
        collapseRow: 'Hide details for handshake {{id}}',
        expandRow: 'Show details for handshake {{id}}',
        viewSsh: 'View SSH handshakes',
        viewTls: 'View TLS handshakes',
      },
      inventory: {
        statisticTypeViewButtonOff: 'Expand detailed view of {{type}}',
        statisticTypeViewButtonOn: 'Collapse detailed view of {{type}}',
      },
      issues: {
        callAccordionClosed: 'Show call {{callId}}',
        callAccordionOpen: 'Hide call {{callId}}',
        hideIssueList: 'Hide {{category}} issue list',
        instanceDetailsAccordion: 'View details for this instance',
        instanceListItem: 'Show details for {{severity}} severity {{filterStatus}} instance {{instanceNumber}} {{instanceData}}',
        issueAccordion: 'Grouped issues by the severity {{severity}}',
        issueDetailsAccordion: 'View details for issue {{issueNumber}} {{issueName}}',
        issueListItem: 'Show instances for {{severity}} severity {{filterStatus}} issue {{issueNumber}} {{issueName}}',
        operationIdLabel: 'View operation {{operationId}}',
        operationKeyIdLabel: 'View key {{keyId}} in operation {{operationId}}',
        selectAllInstances: 'select all instances for issue {{issueNumber}} for export',
        selectAllIssues: 'select all issues and instances for export',
        selectInstance: 'select instance {{issueNumber}}.{{numberLocal}} for export',
        selectIssue: 'select all instances for issue {{issueNumber}} for export',
        severityToggleChecked: 'Hide {{severity}} severity items',
        severityToggleUnchecked: 'Show {{severity}} severity items',
        showIssueList: 'Show {{category}} issue list',
      },
      keys: {
        keyIdLabel: 'View key {{keyId}}',
        operationLabel: 'View operation {{operationId}} in key {{keyId}}',
        organizationKeyLabel: 'View organization key {{keyId}}',
      },
      operations: {
        idLabel: 'View operation {{operationId}}',
        keyIdLabel: 'View key {{keyId}} with role {{role}}',
        wrappedByKeyIdLabel: 'View wrapping key {{keyId}}',
        wrappedKeyIdLabel: 'View wrapped key {{keyId}}',
      },
    },
    scans: {
      failed: '{{hosts}} failed hosts',
      success: '{{hosts}} successful hosts',
    },
    sensors: {
      application: {
        java: {
          docs: 'View the User Guide for the Java Tracer',
          download: 'Download the Java Tracer, version {{version}}',
        },
        javaScanner: {
          docs: 'View the User Guide for the Java Bytecode Scanner',
          download: 'Download the Java Bytecode Scanner, version {{version}}',
        },
      },
      host: {
        linux: {
          docs: 'View the User Guide for the Linux Scanner',
          download: 'Download the Linux Scanner, version {{version}}',
        },
        windows: {
          docs: 'View the User Guide for the Windows Scanner',
          download: 'Download the Windows Scanner, version {{version}}',
        },
      },
      network: {
        networkAnalyzer: {
          docs: 'View the User Guide for the Network Analyzer',
          download: 'Download the Network Analyzer, version {{version}}',
        },
      },
    },
    tables: {
      changePageSize: 'Change the page size of the table',
    },
    users: {
      actions: 'Edit or delete user',
    },
  },
  access: 'Access',
  accessRequired: 'Access required',
  accessibilityStatement: {
    accessibilityLevels:
      'The Web Accessibility Guidelines 2.1 have three levels of accessibility: A, AA, and AAA. We chose Level AA as the target for our website.',
    aqtiveGuardCTA:
      'If you have trouble accessing any part of the AQtive Guard website, or if you have suggestions for improving the site, we’d like to hear from you.',
    aqtiveGuardCommitment:
      'AQtive Guard is committed to providing a website that is accessible to all. To help ensure all visitors to our website have a positive experience and find the information they need, we’ve been using Web Accessibility Guidelines 2.1, which provides standards for making web content more accessible for all site visitors, including people who are blind or visually impaired.',

    aqtiveGuardLevel: 'We’ve worked hard to make our website accessible for all, and we believe our site is at Level AA accessibility.',
    aqtiveGuardMonitoring: 'We monitor the website regularly to maintain this level, and are committed to fixing accessibility issues when they arise.',
    emailUsAt: 'Email us at <anchor>{{email}}</anchor>.',
    title: 'Accessibility statement',
  },
  account: 'Account',
  accountButtonChildren: {
    admin: 'Admin',
    api: 'API',
    changePassword: 'Change password',
    changelog: 'Changelog',
    logout: 'Logout',
  },
  action: 'Action',
  add: 'Add',
  addException: 'Add exception',
  addExpression: 'Add expression',
  addNewProfile: 'Add New Profile',
  addTesters: 'Add testers',
  addTestersToProject: {
    addTestersToProject: 'Add selected testers to project',
    assignedTesters: 'Assigned testers',
    availableTesters: 'Available testers',
    back: 'Cancel',
    noTestersAssignedYet: 'No testers assigned yet.',
    noTestersAvailable: 'No testers available.',
    removeTestersFromProject: 'Remove selected testers from project',
    submit: 'Update Testers',
    subtitle:
      'Select from the available testers on the left to add to the assigned testers on the right side. To remove a tester select from the right and click the left arrow.',
    title: 'Assign testers to your project',
  },
  advancedFilters: {
    all: 'All',
    defaultDate: 'Select a date',
    fields: {
      allProjects: 'All projects',
      exceptions: 'Exceptions',
      profiles: 'Profiles',
      projects: 'Projects',
      searchProfiles: 'Search profiles',
      searchProjects: 'Search projects',
      searchTags: 'Search tags',
      tags: 'Tags',
      types: 'Types',
    },
    fromDate: 'From {{date}}',
    includeExceptions: 'Include exceptions',
    items: 'items',
    noResultsForCurrentSearch: 'No results for current search',
    search: 'Search...',
    selectElements: 'Select elements',
    shortcuts: {
      allTime: 'All time',
      past30Days: 'Past 30 days',
      past7Days: 'Past 7 days',
      past90Days: 'Past 90 days',
      pastYear: 'Past year',
      today: 'Today',
      yesterday: 'Yesterday',
    },
    timePresets: 'Time Presets',
  },
  algorithm: 'Algorithm',
  algorithms: 'Algorithms',
  all: 'All',
  allIssuesAndInstances: 'All issues and instances',
  allOverviewTypes: 'All overview types',
  allProfiles: 'All profiles',
  allProjects: 'All projects',
  allTags: 'All tags',
  allTheFindings: 'All the findings',
  amount: 'Amount',
  and: 'And',
  api: 'api',
  apiDocs: 'API Documentation',
  apiExplorer: 'API Explorer',
  applications: 'Applications',
  apply: 'Apply',
  aqtiveGuardDiscover: 'AQtive Guard Discover',
  assignProjects: 'Assign projects',
  asymmetric: 'Asymmetric',
  asymmetricAlgorithms: 'Asymmetric Algorithms',
  authenticationErrorMessage: 'Your session has expired. Please log in again.',
  authorizationErrorMessage: "You don't have access to this page. Contact your administrator if you need access.",
  back: 'Back',
  blank: 'Blank',
  blankReportSummary: {
    subtitle1:
      'Your analysis has returned no relevant findings. This can happen when the uploaded trace file is incomplete or empty, or when project exception settings filter out expected data.',
    subtitle2: 'Please review your project exceptions and upload a new trace.',
    title: 'No findings to report',
  },
  blankState: {
    priorityFixes: {
      title: 'Nothing to show yet',
    },
  },
  caCertificate: 'CA Certificate',
  callSite: 'Call site',
  callSites: 'Call sites',
  callSitesGuidance: 'For more details, refer to Call site status in <docs>AQtive Guard User Guide</docs>.',
  calledMethod: 'Called Method',
  callingMethod: 'Calling Method',
  calls: 'Calls',
  cancel: 'Cancel',
  canceled: 'Canceled',
  category: 'Category',
  certificate: 'Certificate',
  certificateDescription: 'The number of days remaining as a valid certificate',
  certificateWithId: 'Certificate {{certificateId}}',
  certificates: 'Certificates',
  certificatesListSubtitle: 'Browse the certificates found across all projects within your organization.',
  changeOwnPassword: {
    back: 'Cancel',
    confirm: {
      focused: 'Confirm password',
      input: 'Confirm the new password',
    },
    current: {
      focused: 'Current password',
      input: 'Type your current password',
    },
    new: {
      focused: 'New password',
      input: 'Type the new password',
    },
    submit: 'Continue',
    subtitle: 'Enter your current password and confirm the new one',
    success: 'Your password has been changed',
    title: 'Change your password',
  },
  ciphersuites: {
    authenticationAlgorithm: 'Auth',
    chevronSelectedTooltip: 'Show handshakes that use this ciphersuite',
    chevronSupportedTooltip: 'Show handshakes that support this ciphersuite',
    emptyCol: '-',
    hashAlgorithm: 'Hash',
    keyExchangeAlgorithm: 'KEX',
    macAlgorithm: 'Mac',
    modeOfOperation: 'Mode of operation',
    onlyRecommended: 'Only recommended by IETF',
    onlySelectedNegotiation: 'Only selected in the negotiation',
    protocol: 'Protocol',
    recommended: 'IETF Recommendation',
    symmetricAlgorithm: 'Symmetric Encryption',
    tabName: 'Ciphersuites',
    version: 'Version',
  },
  close: 'Close',
  collapseInformation: 'Collapse information',
  compare: 'Compare',
  compareReport: 'Compare report',
  comparison: {
    infoMessage: {
      noReportsToCompare: 'There are no reports that you can compare',
      reportDiffFailed: 'Report comparison failed. Please try again.',
      reportsNotDone: 'Cannot generate report comparison for failed or pending reports.',
    },
    inventory: {
      beforeCol: 'Before',
      changeCol: 'Change',
      nowCol: 'Now',
      title: 'Inventory Summary',
      typeCol: 'Type',
    },
    latest: 'latest',
    recreateReportDiffAction: 'Retry',
    tabHeaderChange: 'Change',
    tabHeaderInstances: 'Instances',
    tabHeaderIssues: 'Issues',
    tabHeaderSeverity: 'Severity',
  },
  completed: 'Completed',
  completedAt: 'Completed at',
  completedIn: 'Completed in',
  configure: 'Configure',
  consequences: 'Consequences',
  context: 'Context',
  copiedToClipboard: 'Copied to clipboard',
  count: 'Count',
  coverage: 'Coverage',
  covered: 'Covered',
  createException: {
    back: 'Cancel',
    submit: 'Create',
    title: 'Add new exception',
  },
  createExceptionForm: {
    description: {
      focused: 'Description',
      input: 'Description (optional)',
    },
    term: {
      focused: 'Term',
      help: 'Fully qualified method name, class name, or package prefix. Case-sensitive.',
      input: 'Type the exception term',
    },
    traceType: {
      focused: 'Trace type',
      input: 'Select the trace type',
    },
    type: {
      focused: 'Term type',
      helpBlacklist: "Keep instances that have calls that don't match the exception term",
      helpWhitelist: 'Keep instances that have calls that match the exception term',
      input: 'Select the term type',
    },
  },
  createNewProject: 'Create a new project',
  createNewSlot: 'Create a new slot',
  createNewUser: 'Add a user',
  createProfile: {
    certificateDescription: 'Number of days remaining as a valid certificate',
    defaultSetting: 'Default setting: {{setting}}',
    ecDescription: 'Elliptic curve key lengths',
    expiringCertificateDescription: 'Warning period in days before a certificate expires',
    expiringSoon: {
      label: 'Days (before expiry)',
      title: 'Expiring certificates warning',
    },
    rsaDescription: 'RSA key lengths',
    staleDescription: 'Number of days of the key being stale',
    symmetricDescription: 'Symmetric key lengths',
    thresholds: {
      notSet: 'No {{threshold}} threshold set',
    },
    title: 'Create a {{profileType}} profile',
    units: {
      bits: {
        count: '{{count}} bits',
        from: 'From (bits)',
        to: 'To (bits)',
      },
      days: {
        count: '{{count}} days',
        from: 'From (days)',
        to: 'To (days)',
      },
    },
  },
  createProfileForm: {
    copyOf: 'Copy of {{profileName}}',
    name: {
      focused: 'Profile name',
      help: 'The name must be unique in the organization',
      input: 'Type the name of the profile',
      neq: 'The name must be different than the source profile',
    },
  },
  createProject: {
    project: {
      back: 'Cancel',
      submit: 'Create project',
      subtitle: '',
      title: 'Create a new project',
    },
    projectDone: {
      back: "I'm done",
      integrations: 'Configure Integrations',
      report: {
        submit: 'Next: create a report',
        subtitle:
          'Your project has been created, next you need to create a report so you can start analyzing traces. You can do that now or later from the project dashboard.',
      },
      slot: {
        integrationsEnabled: {
          subtitle: 'Add a slot for your report or configure an integration for this project. You can also add these later from the project dashboard.',
        },
        submit: 'Next: create a slot',
        subtitle:
          'Your project has been created, next you need to create a slot so you can start analyzing traces. You can do that now or later from the project dashboard.',
      },
      tip: 'Tip: Select <bold>Configure integrations</bold> to learn how to export Jira issues directly from this project.',
      title: 'Your {{projectName}} project has been created',
    },
    slot: {
      back: "I'm done",
      report: {
        submit: 'Create report',
        subtitle: 'Before being able to analyze a trace you will need to create a report within the project.',
        title: 'Create a report',
      },
      slot: {
        submit: 'Create slot',
        subtitle: 'Before being able to analyze a trace you will need to create a slot within the project.',
        title: 'Create a slot',
      },
    },
    slotDone: {
      back: "I'm done",
      report: {
        another: 'Create another report',
        subtitle: 'You can choose to start a trace analysis, create another report or return to the dashboard.',
        title: 'Your report {{slotName}} has been created',
      },
      slot: {
        another: 'Create another slot',
        subtitle: 'You can choose to start a trace analysis, create another slot or return to the dashboard.',
        title: 'Your slot {{slotName}} has been created',
      },
      submit: 'Next: analyze a trace',
    },
    upload: {
      report: {
        subtitle: 'Upload a trace to automatically start its analysis, make sure it matches the report type or the analysis will fail.',
      },
      slot: {
        subtitle: 'Upload a trace to automatically start its analysis, make sure it matches the slot type or the analysis will fail.',
      },
      title: 'Analyze a trace',
    },
    uploadDone: {
      back: "I'm done",
      submit: 'See report',
      subtitle: 'We are currently analyzing your trace. We will let you know once the report is complete.',
      title: 'Your report {{reportName}} has been created',
    },
  },
  createScanForm: {
    affectedHosts: 'Estimated number of affected hosts:',
    back: 'Cancel',
    estimatingAffectedHosts: 'Estimating...',
    exclude: {
      focused: 'Excluded directories (Optional)',
      input: 'Exclude directories from being scanned',
    },
    hostActivity: {
      focused: 'Host Activity (Optional)',
      help: '\u{26A0} Includes only hosts that have pinged in the specified period',
      input: 'Select an optional host activity for the scan',
    },
    hostname: {
      focused: 'Hostname (Optional)',
      help: '\u{26A0} Includes only hosts that have this as part of their name',
      input: 'Type an optional hostname for the scan',
    },
    maxFileSize: {
      focused: 'Max file size (Defaults to 1000000 [1MB]; 0 disables to cutoff)',
      input: 'Set max file size',
    },
    maxFilesPerSecond: {
      focused: 'Max files per second (Defaults to 0, which is no limit)',
      input: 'Set max files per second',
    },
    name: {
      focused: 'Scan name',
      input: 'Type the scan name',
    },
    platform: {
      focused: 'Platform',
      input: 'Select the platform(s)',
    },
    profile: {
      focused: 'Profile (Defaults to project default one)',
      input: 'Select the profile',
    },
    project: {
      focused: 'Project',
      input: 'Select the project',
    },
    submit: 'Start A Scan',
    tags: {
      focused: 'Tags (Optional)',
      input: 'Add tags',
    },
    workLoad: {
      focused: 'Workload (Defaults to 5% CPU)',
      input: 'Set workload',
    },
  },
  createSlot: {
    slot: {
      back: 'Cancel',
      submit: 'Create slot',
      subtitle: 'Before being able to analyze a trace you will need to create a slot within the project.',
      title: 'Create a slot',
    },
    slotDone: {
      another: 'Create another slot',
      back: "I'm done",
      submit: 'Next: analyze a trace',
      subtitle: 'You can choose to start a trace analysis, create another slot or return to the dashboard.',
      title: 'Your slot {{slotName}} has been created',
    },
    upload: {
      subtitle: 'Upload a trace to automatically start its analysis, make sure it matches the report type or the analysis will fail.',
      title: 'Analyze a trace',
    },
    uploadDone: {
      another: 'Create another report',
      back: "I'm done",
      submit: 'See report',
      subtitle: 'We are currently analyzing your trace. We will let you know once the report is complete.',
      title: 'Your report {{reportName}} has been created',
    },
  },
  createUser: {
    back: 'Cancel',
    done: {
      subtitle: 'Make sure you deliver the password to enable login',
      testerTip: 'This user can only access assigned projects. You can assign projects now or later from the Projects list.',
      title: 'User {{username}} has been created',
    },
    submit: 'Confirm',
    title: 'Create user',
  },
  createUserForm: {
    confirmPassword: {
      focused: 'Confirm password',
      input: 'Confirm the password of the user',
    },
    level: {
      focused: 'Permission level',
      input: 'Enter the permission level of the user',
    },
    name: {
      focused: 'Username',
      help: 'The user name must be unique in the organization. Leading and trailing whitespaces are ignored.',
      input: 'Type the user login name',
    },
    password: {
      focused: 'Password',
      input: 'Create a password for the user',
    },
    preferredName: {
      focused: 'Preferred name',
      input: 'Type an optional display name for the user',
    },
    roles: {
      focused: 'Roles',
      input: 'Enter the roles of the user',
    },
  },
  creationFormSummary: {
    project: 'Project name',
    projectDescription: 'Project description',
    report: {
      report: 'Version name',
      slot: 'Report name',
    },
    slot: {
      report: 'Report name',
      slot: 'Slot name',
    },
    trace: 'Trace',
  },
  critical: 'Critical',
  criticality: {
    filtered: 'Filtered',
    high: 'High Criticality',
    low: 'Low Criticality',
    med: 'Medium Criticality',
    passed: 'Passed',
  },
  crowdstrike: 'CrowdStrike',
  cryptoLibrarySecurityTitle: 'Crypto library security',
  cryptographyOperationsStatistics: 'Cryptography Operations Statistics',
  csv: 'CSV',
  dashboard: 'Dashboard',
  dashboardOverviewSubtitle: 'View and manage your projects. Select a project to view the issues within it.',
  dateRange: 'Date range',
  defaultProfile: 'Default profile',
  delete: 'Delete',
  deleteException: {
    back: 'Cancel',
    content:
      '<color_gray>Deleting this exception will only affect new analyses.<br/>Existing analyses will reflect any Exceptions set when the analysis was created.<br/></color_gray>',
    submit: 'I understand, delete the exception',
    title: 'Delete project exception',
  },
  deleteProfile: {
    back: 'Cancel',
    content:
      '<color_gray>To delete this profile <bold>type the name of the profile exactly as it appears</bold> on the profiles page in the field below.<br/>Once you delete a profile, there is no going back. Please be certain.<br/>This action cannot be undone.<br/></color_gray>Please type <bold>{{profileName}}</bold> to confirm.',
    name: {
      focused: 'Name',
      input: "Type this profile's name exactly as it is shown to confirm deletion",
    },
    submit: 'I understand the consequences, please delete this profile',
    title: 'Delete profile',
  },
  deleteProject: {
    back: 'Cancel',
    content:
      '<color_gray>To delete this project <bold>type the name of the project exactly as it appears</bold> on the all projects page in the field below.<br/>Once you delete a project, there is no going back. Please be certain.<br/>This action cannot be undone. This will permanently delete the project, reports, users, traces, and remove all integrations.<br/></color_gray>Please type <bold>{{projectName}}</bold> to confirm.',
    name: {
      focused: 'Name',
      input: "Type this project's name exactly as it is shown to fully delete all records",
    },
    submit: 'I understand the consequences, please delete this project',
    subtitle: '',
    title: 'Delete your project',
  },
  deleteSlot: {
    back: 'Cancel',
    content:
      '<color_gray>To delete this slot <bold>type the name of the slot exactly as it appears</bold> in your project.<br/>Once you delete a slot, there is no going back. Please be certain.<br/>This action cannot be undone. This will permanently delete the slot, versions and traces.<br/></color_gray>Please type <bold>{{slotName}}</bold> to confirm.',
    name: {
      focused: 'Name',
      input: 'Type the slot name exactly as it is shown to fully delete all records',
    },
    submit: 'I understand the consequences, please delete this slot',
    subtitle: '',
    title: 'Delete your slot',
  },
  deleteUser: {
    back: 'Cancel',
    content:
      '<color_gray>To delete this user <bold>type the name of the user exactly as it appears</bold> on the users page in the field below.<br/>Once you delete a user, there is no going back. Please be certain.<br/>This action cannot be undone.<br/></color_gray>Please type <bold>{{username}}</bold> to confirm.',
    name: {
      focused: 'Name',
      input: "Type this user's name exactly as it is shown to confirm deletion",
    },
    submit: 'I understand the consequences, please delete this user',
    success: 'User {{username}} has been deleted',
    title: 'Delete user',
  },
  description: 'Description',
  details: 'Details',
  detailsForCertificateId: 'Details for Certificate {{certificateId}}',
  detailsForKeyId: 'Details for Key {{keyId}}',
  detailsForOperationId: 'Details for Operation {{operationId}}',
  dh: 'DH',
  digest: 'Digest',
  digestAlgorithm: 'Digest algorithm',
  disabled: 'Disabled',
  disabledIssues: 'Disabled',
  doNotIncludeDismissedInstances: 'Issues and instances, excluding <bold>dismissed</bold>',
  docker: 'Docker',
  download: 'Download',
  downloadJsonFileDescription: 'Export full analysis data.',
  downloadJsonFileSubtext: 'Includes discovered issues, operations, inventory, calls, and stack traces.',
  dragDrop: 'Click to upload or drag and drop',
  dsa: 'DSA',
  duplicate: 'Duplicate',
  duplicateProfile: 'Duplicate profile',
  duration: 'Duration',
  ec: 'EC',
  edit: 'Edit',
  editExpression: 'Edit expression "{{expressionLabel}}"',
  emptyIssuesActionsSensors: 'Change the filter or <anchor>download our sensors</anchor> and generate a new report',
  emptyProjectsActions: 'Change the filter to get results.',
  emptyWorkspace: 'Your workspace is currently empty.',
  enabled: 'Enabled',
  encryptionPayload: 'Encryption payload',
  errorNoOptionsFoundForFilter: 'Options are required for this input type.',
  exceptions: 'Exceptions',
  exceptionsAreActiveInTheProjectInstance:
    'Exceptions are active in this project, so some calls may not be visible. To edit the exceptions, please use the <anchor>project exceptions page</anchor>.',
  exceptionsBlankState: {
    message: 'No exceptions are configured for this project',
    noPermission: 'Contact your administrator to add exceptions',
  },
  exceptionsConsderations: 'For guidance and best practices, refer to Exception considerations in the <docs>AQtive Guard User Guide</docs>.',
  exceptionsExamples: {
    bad1: 'The exception <bold>"Does not contain javax.crypto.Cipher"</bold> is not a good exception, as it will <color_red><bold>remove all calls</bold></color_red> to ciphers from your reports.',
    bad2: 'The exception <bold>"Does not contain toString"</bold> is not a good exception, as it\'s highly likely to <color_red><bold>unintentionally remove other calls</bold></color_red>.',
    good1:
      'The exception <bold>"Does not contain org.myorg.mypackage.MyClass.myMethod"</bold> <color_green><bold>is a good exception</bold></color_green>. It\'s very unlikely to unintentionally remove calls.',
  },
  exceptionsGuidance: 'For guidance and best practices, refer to Exception fundamentals in the <docs>AQtive Guard User Guide</docs>.',
  exceptionsTypes: {
    blacklist: 'Does not contain',
    whitelist: 'Contains',
  },
  expandInformation: 'Expand information',
  expertise: 'Expertise',
  expertiseRequired: 'Expertise required',
  expiryDate: 'Expiry date',
  explanation: 'Explanation',
  export: 'Export',
  exportConfirmation: {
    cancel: 'Cancel',
    export: 'Export',
    subtitle: 'You have selected more than 50 instances to export.',
    title: 'Export {{instances}} instances?',
  },
  exportDrawer: {
    instances: 'Instance(s)',
    issues: 'Issue(s)',
  },
  exportFormats: {
    csv: {
      org: "Export a detailed view of your organization's cryptography that includes issues, instances, and cryptographic inventory. Each section is exported as a separate CSV file.",
      project: 'Export a detailed project view that includes all issues and full cryptographic inventory. Each section is exported as a separate CSV file.',
      report:
        'Export a detailed view of the report that includes all issues, instances, cryptographic inventory, and related cryptography statistics. Each section is exported as a separate CSV file.',
    },
    disabled: 'Manual selection is not available for {{type}} export. Remove the manually selected issues or instances to export the entire report.',
    exportProgress: {
      cancelExportTooltip: 'Cancel export',
      canceledByUser: 'Export was canceled by user',
      inProgress: 'Exporting {{exportedCount}} / {{totalCount}}',
      isDone: 'Exported {{exportedCount}} instances',
    },
    jira: {
      batchExport: 'Create a Jira issue for each failed instance identified in the report',
      multiSelect: 'Create a Jira issue for each of the selected instances.',
      report: 'Create a Jira issue for each of the 50 highest-severity failed instances identified in the report.',
    },
    print: {
      org: "Print or export a PDF overview of your organization's cryptography that includes a summary of failed issues, instances, and cryptographic inventory.",
      project: 'Print or export a PDF overview of the current project status that includes a summary of failed issues and cryptographic inventory.',
      report:
        'Print or export a PDF overview of the report that includes a summary of failed issues, instances, cryptographic inventory, and related statistics.',
    },
    serviceNow: {
      multiSelect: 'Create an incident in ServiceNow for each of the selected instances.',
      report: 'Create an incident in ServiceNow for each failed instance identified in the report',
    },
  },
  exportHiddenIssues: 'Only priority issues are displayed',
  exportOnlyHiddenIssues: 'No priority issues to display',
  exportTitles: {
    manualSelection: 'Manual Selection',
    org: 'Dashboard Export',
    project: 'Project Export',
    report: 'Report Export',
  },
  exportWithCount: 'Export ({{count}})',
  exportsGenericLinkToAQtiveGuard: 'View in AQtive Guard',
  extensions: 'Extensions',
  failed: 'Failed',
  failedInstances: 'Failed instances',
  failedInstancesExceptDismissed: 'Failed instances (excludes <bold>dismissed</bold>)',
  failedToFetchPresets: 'Failed to fetch data from the server, please try again in a minute.',
  false: 'False',
  fileSystems: 'File systems',
  fileType: 'File type',
  fileTypeLabel: {
    certificate: 'Certificate',
    jar: 'JAR',
    jceksKeystore: 'JCEKS',
    jksKeystore: 'JKS',
    otherKey: 'Other Key',
    pgpKey: 'PGP Key',
    pkcs12Keystore: 'PKCS12',
    pkcs1Key: 'PKCS#1 Key',
    pkcs7: 'PKCS#7 File',
    pkcs8Key: 'PKCS#8 Key',
    ppk: 'PPK Key',
    sharedLib: 'Shared library',
    sshKey: 'SSH Key',
    sstKeystore: 'Microsoft Serialized Certificate Store',
    unknown: 'Unidentified',
    x509Key: 'X.509 Key',
  },
  filterBy: 'Filter by',
  filterExceptionsFromThisViewOfProject: 'Filter exceptions from this view of {{projectName}}',
  filterLabels: {
    contains: 'contains',
    has: 'has',
    is: 'is',
    isAfter: 'is after',
    isAfterOrEqual: 'is after or at',
    isBefore: 'is before',
    isBeforeOrEqual: 'is before or at',
    isGreater: 'is greater than',
    isGreaterOrEqual: 'is greater or equal than',
    isLess: 'is less than',
    isLessOrEqual: 'is less or equal than',
    isNot: 'is not',
    isSelected: 'is selected',
    isSupported: 'is supported',
  },
  filterOnTags: 'Filter on tags',
  filteredIssues: 'Filtered',
  filters: 'Filters',
  fingerprint: 'Fingerprint',
  firstCall: 'First call',
  footer: {
    a11yStatement: 'Accessibility Statement',
    company: '© {{year}} SandboxAQ SB Technology, Inc.',
    useConditions: 'Use Conditions',
  },
  forgotPassword: 'Forgot password',
  foundInLocations_one: 'Found in 1 location',
  foundInLocations_other: 'Found in {{count}} locations',
  from: 'from',
  fuzzer: 'Fuzzer',
  fuzzerRuleset: {
    compliance: 'Compliance rules',
    vulnerability: 'Vulnerability rules',
  },
  generatedAt: 'Generated at',
  getStartedBy: {
    addUser: 'add a user',
    createProject: 'create a project',
    downloadTools: 'download our sensors',
  },
  getStartedBy_1: 'To get started, <anchor_0>{{anchor_0}}</anchor_0>',
  getStartedBy_2: 'To get started, <anchor_0>{{anchor_0}}</anchor_0> or <anchor_1>{{anchor_1}}</anchor_1>',
  getStartedBy_3: 'To get started, <anchor_0>{{anchor_0}}</anchor_0>, <anchor_1>{{anchor_1}}</anchor_1> or <anchor_2>{{anchor_2}}</anchor_2>',
  handshakes: {
    ciphersuite: 'Ciphersuite',
    emptyCol: '-',
    emptyDate: '-',
    properties: {
      status: {
        INCOMPLETE: 'Incomplete',
        SUCCESS: 'Success',
      },
    },
    protocols: {
      protocol: 'Protocol',
      ssh: 'SSH',
      tls: 'TLS',
    },
    serverName: 'Server',
    sourceIp: 'Source IP',
    sourcePort: 'Source port',
    sshDetails: {
      client: 'Client',
      clientSupport: 'Client support',
      comments: 'Software comments',
      hostAlg: 'Host key algorithms',
      kex: 'Key exchange',
      macCS: 'MAC\n(Client / Server)',
      macSC: 'MAC\n(Server / Client)',
      protocolVersion: 'Protocol version',
      selectedAlgorithm: 'Selected algorithm',
      server: 'Server',
      serverSupport: 'Server support',
      softwareVersion: 'Software version',
      symCS: 'Symmetric algorithms\n(Client / Server)',
      symSC: 'Symmetric algorithms\n(Server / Client)',
    },
    sshHandshake: 'SSH Handshake',
    status: 'Status',
    tabName: 'Handshakes',
    targetIp: 'Destination IP',
    targetPort: 'Destination port',
    timestamp: 'Timestamp',
    tlsHandshake: 'TLS Handshake',
    version: 'Version',
  },
  hardCodedStringSourceCodeLocations: 'Hard-coded string source code locations',
  hasPrivateKey: 'Has private key',
  hashFunctions: 'HASH functions',
  helpTexts: {
    asymmetricAlgorithms:
      'Asymmetric algorithms involve a pair of keys: a public key for encryption and a private key for decryption, to enable secure communications without the need to exchange secret keys.',
    asymmetricKeys:
      'Asymmetric cryptography uses a pair of keys: a public key, which is used for encryption, and a private key, which is kept confidential and used for decryption.',
    hashFunctions: 'A hash function is a basic building block of many cryptographic protocols.',
    inPolicy: 'Percentage of instances that are in policy as defined by the profile used for analysis.',
    keyStores: 'Java crypto engine (JCE) APIs provide an abstraction for key-management called keystores.',
    mac: 'MAC (Message Authentication Code) is a secure code that confirms the authenticity and integrity of a message using a combination of a secret key and a hash function.',
    operations: 'Cryptographic operations are specific tasks or methods performed with cryptographic keys and algorithms to secure or authenticate data.',
    outOfPolicy: 'Percentage of instances that are out of policy as defined by the profile used for analysis.',
    priorityIssues: 'In AQtive Guard, a Priority issue flags one or more instances of a rule that failed to pass the criteria set in the analysis profile.',
    symmetricAlgorithms: 'Symmetric algorithms use the same secret key for both encryption and decryption of data, requiring secure key management practices.',
    symmetricKeys: 'In symmetric cryptography, the same key is utilized for both encrypting and decrypting data, necessitating secure key sharing.',
  },
  hideFilters: 'Hide filters',
  high: 'High',
  home: 'Home',
  hostActivity: 'Last {{value}} hours',
  hostName: 'Host name',
  hostScan: {
    id: 'ID',
    name: 'Name',
    originId: 'Origin ID',
    platform: 'Platform',
    report: 'Report',
    reportDeleted: 'This report has been deleted.',
    status: 'Status',
    statusReason: 'Status reason',
  },
  hostStatus: {
    canceled: 'Canceled',
    downloadedTrace: 'Downloaded trace from host',
    downloadingTrace: 'Downloading trace from host',
    fail: 'Fail',
    pending: 'Pending start',
    retrievedTrace: 'Retrieved trace information',
    retrievingTrace: 'Retrieving trace information',
    scanning: 'Scanning',
    settingUp: 'Setting up',
    success: 'Success',
  },
  id: 'ID',
  imageInfo: 'Image information',
  imageInfoDetail: '{{imageType}} image: {{imageInfo}}',
  inPolicy: 'In policy',
  inProgress: 'In Progress',
  includeFilteredIssues: 'Include filtered issues and instances',
  includeOnlyStarredInstances: 'Issues and only <bold>starred</bold> instances (with stack traces and remediation)',
  includes: 'Includes',
  insertExpression: 'Insert expression',
  insertGroup: 'Insert group',
  instanceFilterStatus: {
    FULLY_KEPT: 'Not filtered',
    NOT_KEPT: 'Completely filtered',
    PARTIALLY_KEPT: 'Partially filtered',
  },
  instances: 'Instances',
  instancesFound: 'Instances found',
  instancesListEmpty: 'No instance found for the selected severities',
  integrationList: {
    configured: 'Active',
    crowdstrike: {
      baseUrlLabel: 'Base URL',
      clientIdLabel: 'Client ID',
      clientSecretLabel: 'Client Secret',
      connectButton: 'Update',
      description: 'Linking a CrowdStrike instance to the Analyzer enables endpoint status checks for quick threat identification and resolution.',
      subtitle: 'Manage and configure CrowdStrike integration with your organization.',
      testButton: 'Test connection',
      testFail: 'CrowdStrike failed to connect',
      testSuccess: 'CrowdStrike connection is correctly configured',
      title: 'CrowdStrike',
      unlinkButton: 'Unlink',
      updateSuccess: 'CrowdStrike integration updated',
    },
    jiraDescription: 'Linking to JIRA enables you to export instances in a report as JIRA issues either individually or in bulk.',
    jiraExport: {
      additionalInfo: 'Refer to the <docs>AQtive Guard User Guide</docs> for all integration requirements and instructions.',
      description: 'Enable exporting one or more instances from AQtive Guard to automatically create linked issues in Jira.',
      linkButton: 'Select',
      testButton: 'Test connection',
      testFail: 'Jira failed to connect',
      testSuccess: 'Jira connection is correctly configured',
      title: 'Jira issue export',
    },
    jiraIssueCollector: {
      additionalInfo: '<bold>IMPORTANT:</bold> Form integration is only available in Jira configurations running company-managed projects.',
      alert: 'Log into Jira as an <bold>Administrator</bold> to complete the following steps',
      description: 'Enable launching an editable form from AQtive Guard to submit an instance as a linked Jira issue.',
      linkButton: 'Select',
      steps: {
        step_1: 'In your target Jira project, select <bold>Project Settings.</bold>',
        step_2: 'Select <bold>Issues</bold>, then <bold>Collectors.</bold>',
        step_3: 'Select <bold>Add issue collector.</bold>',
        step_4: 'Fill out the required fields. For guidance, refer to <docs>AQtive Guard User Guide</docs>.',
        step_5: 'Select the <bold>Embed in HTML</bold> tab and copy the generated code snippet here.',
      },
      subtitle: 'Configuration requires a Jira <bold>company-managed project</bold> to receive AQtive Guard instances',
      title: 'Jira form integration',
    },
    jiraTitle: 'Jira',
    newIntegration: 'New',
    noPermission: 'Contact your administrator to configure this integration.',
    notConfigured: 'Not configured',
    optional: 'Optional',
    serviceNow: {
      connectButton: 'Update',
      description:
        'Linking ServiceNow instance to the Analyzer enables real-time incident management and resolution, providing quick visibility into the status of IT services',
      instanceUrlLabel: 'Instance URL',
      notConfiguredForYourOrganization: "The ServiceNow integration isn't configured for your organization.",
      passwordLabel: 'Password',
      subtitle: 'Manage and configure ServiceNow integration with your organization.',
      testButton: 'Test connection',
      testFail: 'ServiceNow failed to connect',
      testSuccess: 'ServiceNow connection is correctly configured',
      title: 'ServiceNow',
      unlinkButton: 'Unlink',
      unlinkSuccess: 'ServiceNow integration has been unlinked',
      updateSuccess: 'ServiceNow integration updated',
      userIDLabel: 'User ID',
      viewExportedRecord: 'View exported record',
    },
    subtitle: 'Manage and configure any third party integrations your organization interfaces with.',
    tanium: {
      accessTokenLabel: 'Access Token',
      certificateLabel: 'Trusted CA Certificate',
      connectButton: 'Update',
      description: 'Linking a Tanium instance to the Analyzer enables endpoint status checks for quick threat identification and resolution.',
      instanceUrlLabel: 'Instance URL',
      maxConcurrentLabel: 'Max # of parallel trace uploads',
      requestRateLabel: 'Max calls rate to the Tanium API (calls per min)',
      subtitle: 'Manage and configure Tanium integration with your organization.',
      testButton: 'Test connection',
      testFail: 'Tanium failed to connect',
      testSuccess: 'Tanium connection is correctly configured',
      title: 'Tanium',
      unlinkButton: 'Unlink',
      updateSuccess: 'Tanium integration updated',
    },
    unlinkModal: {
      goBack: 'Go Back',
      unlink: 'Unlink',
      unlinkSubtitle: "If you unlink, information transfer will stop and you'll need to reconfigure.",
      unlinkTitle: 'Unlink {{integration}}?',
    },
    venafi: {
      accessTokenLabel: 'Access Token',
      certificateLabel: 'Trusted CA Certificate',
      connectButton: 'Update',
      description: 'Linking a Venafi instance to the Analyzer enables you to check the status of detected certificates in the Venafi database.',
      instanceUrlLabel: 'Instance URL',
      subtitle: 'Manage and configure Venafi integration with your organization.',
      testButton: 'Test connection',
      testFail: 'Venafi failed to connect',
      testSuccess: 'Venafi connection is correctly configured',
      title: 'Venafi',
      unlinkButton: 'Unlink',
      updateSuccess: 'Venafi integration updated',
    },
  },
  integrations: 'Integrations',
  integrationsListSubtitle: 'Manage and configure any third party integrations your organization interfaces with.',
  inventoryAndIssueOverview: 'Inventory and issue overview',
  inventorySummary: 'Inventory summary',
  inventorySummarySubtitle: 'Explore your cryptographic inventory',
  issue: 'Issue',
  issueListEmpty: 'No issue found for the selected severities',
  issuer: 'Issuer',
  issues: 'Issues',
  issues_one: '1 Issue',
  issues_other: '{{count}} Issues',
  jira: 'Jira',
  jiraExportErrors: {
    generic: 'please check your JIRA project configuration and try again.',
    issueType: 'JIRA Issue Type "{{value}}" is not available in your project.\nCheck your JIRA configuration and try again.',
    priority: 'JIRA Priority "{{value}}" is not available in your project.\nCheck your JIRA configuration and try again.',
    project: 'JIRA Project Key "{{value}}" is not available in your project.\nCheck your JIRA configuration and try again.',
  },
  jiraExportFailure: 'Something went wrong: {{error}}\nIf the problem persists, contact support.',
  jiraExportPartial:
    'Successfully exported {{success}} instances to JIRA.\n{{failed}} instances could not be exported: {{error}}\nIf the problem persists, contact support.',
  jiraExportReportLimit: 'Only the first 50 highest-severity failed instances will be exported',
  jiraExportSuccess_one: 'Successfully exported {{count}} instance to JIRA',
  jiraExportSuccess_other: 'Successfully exported {{count}} instances to JIRA',
  jiraExportZero: 'This report has no failed instances to export',
  jiraExportZeroExceptionsAvailable:
    'Project exceptions exclude all failed instances of this report.\nInclude filtered issues from the Issues tab and try again.',
  jiraIsNotConfiguredInYourOrganization: "The JIRA integration isn't configured for your organization.",
  jiraIssueCollector: {
    defaultValue: 'Paste issue collector embed code here',
    description: '<color_black><bold>IMPORTANT:</bold></color_black> Configure a collector form with a custom trigger.',
    errors: {
      generic: 'Failed to load the issue collector, please try again',
      invalid: 'Invalid issue collector, please check your configuration and try again',
      timeout: 'Failed to load the issue collector, check your connection and try again',
    },
    inputError: 'The issue collector code is invalid.',
    inputHeader: 'Embed issue collector',
    inputLabel: 'Issue collector code',
    save: 'Save',
    unlink: 'Unlink',
    updated: 'Issue collector is successfully updated',
  },
  jiraIssueExport: {
    back: 'Back',
    baseUrlInputLabel: 'Base URL of your Jira instance',
    baseUrlUpdated: 'The Jira instance URL has been configured successfully',
    cancel: 'Cancel',
    configurationSucess: 'Jira configuration is successful',
    configuredIntegration: {
      message: 'Your Jira link is configured.',
      secondaryMessage: {
        jiraFieldsConfigured: 'Return here to update your <bold>Jira Project Key</bold> or <bold>Issue Type,</bold> or to <bold>Unlink</bold> the integration.',
        jiraFieldsNotConfigured:
          'To export issues, set a <bold>Jira Project Key</bold> and default <bold>Issue Type</bold>. To disconnect the integration, select <bold>Unlink.</bold>',
      },
    },
    finish: 'Finish',
    finishConfiguration: {
      instruction: 'Enter Jira project information and select <bold>Finish</bold> to complete the integration.',
      secondaryInstruction:
        'The <bold>Jira Project Key</bold> and default <bold>Issue Type</bold> are required for the integration to function, but you can return to update them at any time.',
    },
    issueTypeInputLabel: 'Issue Type',
    link: 'Link',
    linkEstablished: 'The Jira link has been established',
    linkInstructions: {
      step1: 'In Jira, select the <bold>Settings Gear</bold> at the top right of any page, then select <bold>Products.</bold>',
      step2: 'In the left-side integrations menu select <bold>Application links</bold>, then <bold>Create link.</bold>',
      step3: {
        applicationUrl: 'Application URL',
        instruction: 'Select <bold>Direct Application Link.</bold> Paste this Application URL where requested and click <bold>Continue.</bold>',
        secondaryInstruction: '<italic>If prompted, select the <bold>Use this URL</bold> checkbox, then <bold>Continue.</bold></italic>',
      },
      step4: {
        applicationName: 'Application Name',
        applicationType: 'Application Type',
        aqtiveGuardApplicationName: 'AQtive Guard',
        genericApplication: 'Generic Application',
        instruction: 'Fill in the application name and select the application type',
        secondaryInstruction: '<italic>Ignore the remaining form fields and <bold>Continue.</bold></italic>',
      },
      step5: {
        aqtiveGuardConsumerName: 'AQtive Guard',
        consumerKey: 'Consumer Key',
        consumerName: 'Consumer Name',
        instruction:
          'To configure the link, locate AQtive Guard, and expand the three-dot kebab menu at the right end of the row. Select <bold>Edit</bold>, then <bold>Incoming Authentication</bold> to enter the remaining information:',
        publicKey: 'Public Key',
        secondaryInstruction: '<italic>Make sure to <bold>Save</bold> your edits and <bold>Close.</bold></italic>',
      },
      step6: {
        instruction: 'Select <bold>Link</bold> below to continue the configuration.',
      },
    },
    modal: {
      cancelMessage: 'Cancel integration setup?',
      cancelSubtitle: 'If you cancel, your information will not be saved.',
      goBack: 'Go Back',
      unlinkTip: 'Tip: Select <bold>GO BACK</bold> to change the <bold>Jira Project Key</bold> or default <bold>Issue Type</bold>.',
    },
    next: 'Next',
    projectKeyInputLabel: 'Jira Project Key',
    save: 'Save',
    tabLabelFinishConfiguration: 'Finish configuration',
    tabLabelJiraUrl: 'Configure your Jira instance URL',
    tabLabelLinkInstance: 'Configure your Jira instance and initiate the link',
    unlink: 'Unlink',
    unlinkSuccess: 'Jira integration has been unlinked',
  },
  jiraSubtitle: 'Manage and configure Jira integration with your organization.',
  json: 'JSON',
  keptByFilters: 'Kept by filters',
  key: 'Key',
  keyInformation: 'Key information',
  keyInstancesSubtitle: "Examine the occurrences of this key throughout your organization's projects and reports",
  keyInstancesTitle: 'Key instances',
  keyLength: 'Key length',
  keyLengthInvalidOtherFilter: '"Other" can only be used with the "is" operator',
  keyMetadata: 'Key metadata',
  keyProperties: {
    categories: {
      PRIVATE: 'Private',
      PUBLIC: 'Public',
      SYMMETRIC: 'Symmetric',
    },
    locations: {
      CERTIFICATE: 'Certificate',
      JAR: 'JAR',
      JCEKS_KEYSTORE: 'JCEKS',
      JKS_KEYSTORE: 'JKS',
      OTHER_KEY: 'Other Key',
      PGP: 'PGP Key',
      PKCS12_KEYSTORE: 'PKCS12',
      PKCS1_KEY: 'PKCS#1 Key',
      PKCS7: 'PKCS#7 File',
      PKCS8_KEY: 'PKCS#8 Key',
      PPK: 'PPK Key',
      SHARED_LIBRARY: 'Shared library',
      SSH_KEY: 'SSH Key',
      UNKNOWN: 'Unidentified',
      X509_KEY: 'X.509 Key',
    },
    operations: {
      DECRYPTION: 'Decryption',
      ENCRYPTION: 'Encryption',
      EXCHANGED: 'Exchanged',
      GENERATED: 'Generated',
      KEY_AGREEMENT: 'Key agreement',
      KEY_DEFINITION: 'Key definition',
      KEY_DERIVATION: 'Key derivation',
      LOADED: 'Loaded',
      MAC_COMPUTATION: 'MAC computation',
      NO_OPERATION: 'No operation',
      SIGNATURE: 'Signature',
      STORED: 'Stored',
      UNWRAPPING: 'Unwrapping',
      VERIFICATION: 'Verification',
      WRAPPING: 'Wrapping',
    },
    sources: {
      AWS_KMS: 'AWS KMS Keys',
      AZURE_KEY_VAULT: 'Azure Key Vault keys',
      CREATED: 'Created',
      DERIVED: 'Derived',
      EXCHANGED: 'Exchanged',
      GENERATED: 'Generated',
      KEYSTORE: 'Keystore',
      UNKNOWN: 'Unknown',
    },
    types: {
      DH: 'DH',
      DILITHIUM: 'Dilithium',
      DSA: 'DSA',
      EC: 'EC',
      FALCON: 'Falcon',
      PASSWORD_BASED: 'Password based',
      RSA: 'RSA',
      SPHINCS: 'Sphincs',
      SYMMETRIC: 'Symmetric',
    },
  },
  keyRole: 'Key role',
  keyStore: 'Key store',
  keyType: 'Key type',
  keyValue: 'Key value',
  keyWithId: 'Key {{keyId}}',
  keys: 'Keys',
  keysListSubtitle: 'Browse the keys found across all projects within your organization.',
  lastAnalysis: 'Last analysis',
  lastTraceAnalyzed: 'Last trace analyzed: {{date}}',
  lastUsed: 'Last Used',
  latestTrace: 'Latest trace',
  line: 'Line',
  loadErrorMessage: 'Something went wrong. Please refresh the page to try again.',
  location: 'Location',
  locations: 'Locations',
  loggedIn: 'Logged in.',
  loggingOut: "Your session has expired, you're being logged out",
  lookingToCreateNewAException: 'Looking to create new a exception? <anchor>Click here</anchor>',
  low: 'Low',
  mac: 'MAC',
  matchedCertificates: 'Matched certificates',
  matchedKeys: 'Matched keys',
  medium: 'Medium',
  method: 'Method',
  metric: 'Metric',
  missed: 'Missed',
  more: 'More',
  moreThan: 'more than',
  'n/a': 'N/A',
  naIssues: 'N/A',
  name: 'Name',
  networkAnalyzer: 'Network analyzer',
  never: 'Never',
  neverUsed: 'Never used',
  no: 'No',
  noAlgorithm: 'No algorithm',
  noAnalysisYet: 'No analysis yet',
  noAvailableActions: 'No available actions',
  noData: 'No data',
  noDataToShow: 'No data to show',
  noInformation: 'No information',
  noInstancesPlaceholder: {
    subtitle: 'This issue does not have any instance to display.',
    title: 'No instances available',
  },
  noIssuesPlaceholder: {
    subtitle: 'There are no issues to display for this report',
    title: 'Nothing to display',
  },
  noLastAnalysisInSlot: 'Never',
  noMatchedCertificates: 'No matched certificates',
  noOperations: 'No operations',
  noOverviewTypesSelected: 'No overview types selected',
  noProfile: 'No profile',
  noProfileInReport: 'Unknown',
  noProfileInReportTooltip: 'The profile used to generate this report is not available.',
  noProfileInSlot: 'Empty',
  noProject: 'No project',
  noReportInSlot: 'Empty',
  noReportsYet: 'No reports yet',
  noResults: 'No results',
  noResultsForCurrentFilters: 'No results for current filters',
  noStackTraceToShow: 'No stack trace to show',
  noTagsInSlot: 'Empty',
  noTraceInReport: 'Unknown',
  noTraceInReportTooltip: 'The trace used to generate this report is not available.',
  noTraceInSlot: 'Empty',
  nonExistingCertificate: "This certificate doesn't exist.",
  nonExistingInstance: "This instance doesn't exist.",
  nonExistingIssue: "This issue doesn't exist.",
  nonExistingKey: "This key doesn't exist.",
  nonExistingOperation: "This operation doesn't exist.",
  nonExistingPage: "This page doesn't exist.",
  nonExistingProfile: "This profile doesn't exist.",
  nonExistingProject: "This project doesn't exist.",
  nonExistingReport: "This report doesn't exist.",
  none: 'None',
  notAfter: 'Not after',
  notBefore: 'Not before',
  notCovered: 'Not Covered',
  notFound: 'Not found',
  notSet: 'Not set',
  of: 'of',
  off: 'Off',
  on: 'On',
  operationProperties: {
    algorithms: {
      AES: 'AES',
      AESWRAP: 'AESWrap',
      BKS: 'BKS',
      BLOWFISH: 'Blowfish',
      CAMELLIA: 'Camellia',
      CAST5: 'CAST5',
      DES: 'DES',
      DES_EDE_2KEY: '2-key 3DES',
      DES_EDE_3KEY: '3-key 3DES',
      DH: 'Diffie-Hellman',
      DSA: 'DSA',
      ECDH: 'ECDH',
      ECDSA: 'ECDSA',
      ECIES: 'ECIES',
      ECMQV: 'ECMQV',
      EVP_BYTESTOKEY: 'EVP_BytesToKey',
      IDEA: 'IDEA',
      JCEKS: 'JCEKS',
      JKS: 'JKS',
      KECCAK224: 'KECCAK-224',
      KECCAK256: 'KECCAK-256',
      KECCAK288: 'KECCAK-288',
      KECCAK384: 'KECCAK-384',
      KECCAK512: 'KECCAK-512',
      MD2: 'MD2',
      MD5: 'MD5',
      PBKDF1: 'PBKDF1',
      PBKDF2: 'PBKDF2',
      PKCS12_PBE: 'PKCS #12',
      RC2: 'RC2',
      RC4: 'RC4',
      RC5: 'RC5',
      RSA: 'RSA',
      SEED: 'SEED',
      SHA1: 'SHA-1',
      SHA224: 'SHA-224',
      SHA256: 'SHA-256',
      SHA384: 'SHA-384',
      SHA3_224: 'SHA3-224',
      SHA3_256: 'SHA3-256',
      SHA3_384: 'SHA3-384',
      SHA3_512: 'SHA3-512',
      SHA512: 'SHA-512',
      SHA512_224: 'SHA-512/224',
      SHA512_256: 'SHA-512/256',
      SUN_JCE_CUSTOM_MD5_TRIPLE_DES: 'SUN JCE custom PBE-MD5-3DES',
    },
    categories: {
      asymmetric_key_generation: 'Asymmetric key generation',
      cloud_storage: 'Cloud storage',
      encryption_decryption: 'Encryption / decryption',
      hashing: 'Hashing',
      key_agreement: 'Key agreement',
      key_definition: 'Key definition',
      key_derivation: 'Key derivation',
      key_store_access: 'Key store access',
      key_store_creation_loading: 'Key store creation / loading',
      key_wrapping_unwrapping: 'Key wrapping / unwrapping',
      mac: 'MAC',
      signature_generation_verification: 'Signature / verification',
      ssh_handshake: 'SSH Handshake',
      symmetric_key_generation: 'Symmetric key generation',
      tls_handshake: 'TLS Handshake',
      tls_initialization: 'TLS or SSL initialization',
    },
    contexts: {
      NON_TLS: 'Non-TLS',
      TLS: 'TLS',
    },
    types: {
      ASYMMETRIC_KEY_GENERATION: 'Asymmetric key generation',
      DECRYPTION: 'Decryption',
      DIGEST: 'Digest',
      ENCRYPTION: 'Encryption',
      KEYSTORE_LOAD: 'Keystore load',
      KEYSTORE_STORE: 'Keystore store',
      KEY_AGREEMENT: 'Key agreement',
      KEY_DEFINITION: 'Key definition',
      MAC: 'MAC',
      PASSWORD_BASED_DERIVATION: 'Password-based key derivation',
      SIGNATURE: 'Signature',
      SIGNATURE_VERIFICATION: 'Signature verification',
      SSH_HANDSHAKE: 'SSH Handshake',
      SYMMETRIC_KEY_GENERATION: 'Symmetric key generation',
      TLS_HANDSHAKE: 'TLS Handshake',
      TLS_INITIALIZATION: 'TLS or SSL initialization',
      UNWRAPPING: 'Unwrapping',
      WRAPPING: 'Wrapping',
    },
  },
  operationType: 'Operation type',
  operations: 'Operations',
  or: 'or',
  organization: 'Organization',
  organizationCertificate: 'Organization certificate',
  organizationDashboard: {
    includePassedInstances: 'Include passed instances',
    instanceSummary: 'Instance summary',
  },
  organizationKey: 'Organization key',
  other: 'Other',
  otherKeys: 'Other keys',
  outOfPolicy: 'Out of policy',
  overview: 'Overview',
  overviewSubtitle: 'Here you can track the latest activity across all your projects.',
  overviewTypes: 'Overview types',
  passed: 'Passed',
  passedIssues: 'Passed',
  password: 'Password',
  passwordBased: 'Password based',
  passwordInput: {
    notEqual: 'The passwords do not match',
    regex: 'The password must be at least 8 characters long, with no leading or trailing whitespaces',
    required: 'The password is required',
  },
  path: 'Path',
  pcks11: {
    cka_class: 'Key class',
    cka_decrypt: 'DECRYPT',
    cka_encrypt: 'ENCRYPT',
    cka_extractable: 'EXTRACTABLE',
    cka_label: 'LABEL',
    cka_local: 'LOCAL',
    cka_modifiable: 'MODIFIABLE',
    cka_private: 'PRIVATE',
    cka_sensitive: 'SENSITIVE',
    cka_sign: 'SIGN',
    cka_token: 'TOKEN',
    cka_unwrap: 'UNWRAP',
    cka_verify: 'VERIFY',
    cka_wrap: 'WRAP',
  },
  pcks11InstancesTitle: 'Key PKCS#11 Attributes',
  pemEncodedCertificate: 'PEM Encoded Certificate',
  pending: 'Pending',
  pleaseSignIntoYourAccount: 'Please sign into your account',
  preferredName: 'Preferred name',
  print: 'Print',
  priorityIssues: 'Priority issues',
  privateKey: 'Private key',
  profile: 'Profile',
  profileListSubtitle: 'Explore and create profiles that can be utilized for analyzing traces.',
  profileType: 'Profile type',
  profileUsed: 'Profile used',
  profiles: 'Profiles',
  progress: 'Progress',
  project: 'Project',
  projectDashboardIssuesSubtitle: 'Explore issues in the project, click on an issue to get more information on its occurrences',
  projectDetails: 'Project Details',
  projectForm: {
    description: 'Project description',
    maxReports: 'Max. report versions per slot',
    name: 'Project name',
    profile: {
      focused: 'Profile',
      input: 'Select profile',
    },
  },
  projectIntegrations: {
    fetchError: 'Error loading project settings',
    integrationsList: {
      jiraTitle: 'Jira',
      taniumTitle: 'Tanium',
    },
    jiraIssueCollector: {
      defaultValue: 'Paste issue collector embed code here',
      formCodeUpdated: 'Issue Collector Code Successfully Updated',
      inputLabel: 'Issue collector code',
      learnMore: 'Configure Jira form integration to enable launching an editable form to submit Jira issues from instances. <docs>Learn More</docs>',
      title: 'Jira Form Integration',
      unlink: 'Unlink',
      unlinked: 'Jira Form Integration Successfully Unlinked',
    },
    jiraIssueExport: {
      baseUrlInputLabel: 'Base URL of your Jira instance',
      fieldsUpdated: 'Jira Export Project Fields Updated',
      issueTypeInputLabel: 'Issue Type',
      learnMore: 'Configure Jira issue export to automatically export Jira issues from one or more instances. <docs>Learn More</docs>',
      notConfigured: 'The link to Jira is not configured for your organization. Please contact your admin to set up the integration.',
      projectKeyInputLabel: 'Jira Project Key',
      testConnection: 'Test Issue Export Connection',
      title: 'Jira Issue Export',
      unlink: 'Unlink',
      unlinked: 'Jira Issue Export Successfully Unlinked',
    },
    noPermission: 'Contact your administrator to configure this integration.',
    projectDetailsUpdated: 'Project details successfully updated',
    projectIntegrations: 'Project Integrations',
    projectSettingsNote: 'Note: These settings apply only to this project. For Organization settings, please visit <anchor>Organization integrations.</anchor>',
    tanium: {
      compGroupInputLabel: 'Computer Group',
      completedAt: 'Last completed retrieval',
      completedRun: 'Tanium traces retrieval has finished successfully',
      computerGroupUpdated: 'Computer Group successfully updated',
      configuration: 'Configuration',
      currentSession: 'Current Session',
      downloadLogs: 'Download Logs',
      emptyData: '-',
      endpoints: 'Endpoints',
      launchRetrieval: 'Launch Retrieval',
      noLogsError: 'No logs are available. \nTry running the retrieval again. If the problem persists, please contact support.',
      noPrevRuns: 'Retrieval is not currently running',
      notConfigured: 'The link to Tanium is not configured for your organization. Please contact your admin to set up the integration.',
      remaining: 'Remaining',
      save: 'Save',
      status: {
        completed: 'Completed',
        queued: 'Queued',
        running: 'Running',
        stopped: 'Stopped',
        stopping: 'Stopping',
      },
      statusLabel: 'Status',
      stop: 'Stop',
      testConnection: 'Test Connection',
      title: 'Tanium',
      unlink: 'Unlink',
      unlinked: 'Tanium Integration successfully unlinked',
    },
    viewOrgIntegrations: 'View Org Integrations',
  },
  projectInventorySummary: 'Inventory summary',
  projectInventorySummarySubtitle: 'Explore your cryptographic inventory',
  projects: 'Projects',
  projectsImpacted: 'Projects impacted',
  projectsListSubtitle: 'Explore and create new projects within your organization.',
  projectsPerPage: 'Projects per page',
  publicKey: 'Public key',
  reference: 'Reference',
  references: 'References',
  refresh: 'Refresh',
  remediation: 'Remediation',
  removeReport: 'Remove report',
  removeSection: 'Remove section',
  report: 'Report',
  reportBug: 'Report a bug',
  reportCallLimiting: {
    callsSummary: {
      limited:
        'Number of calls in trace: {{numCallsTotal}} <color_light>({{numCallsKept}} kept, {{numCallsOverBucketLimit}} over call site limit, {{numCallsOverTotalLimit}} over total limit)</color_light>',
      limitedGeneric: 'Some calls that exceeded these limits were discarded during preparation of this report',
      notLimited: 'No calls were discarded during preparation of this report',
    },
    limitsSummary: {
      default: 'By default, results are limited to the first 1000 calls per call site and 100000 calls overall',
      limited: 'Results are limited to the first {{maxCallsPerBucket}} calls per call site and {{maxCallsTotal}} calls overall',
    },
    sitesSummary: {
      limited: 'Number of call sites: {{numBuckets}} <color_light>({{numFullBuckets}} over per-call-site limit)</color_light>',
    },
  },
  reportCertificates: 'Certificates',
  reportCoverage: 'Trace covers {{covered}} out of {{total}} call sites found by a static scan',
  reportCoverageWithDepth: 'Trace covers {{covered}} out of {{total}} call sites found by a static scan at depth {{depth}}',
  reportDashboardIssuesSubtitle: 'Explore issues in the report, click on an issue to get more information on its occurrences',
  reportDetails: 'Report details',
  reportFailedMessage:
    'The analyzer failed to generate a report for your application trace: {{reason}}.\nTry running the report again. If the problem persists, please contact support.',
  reportGeneratedWithProductionSafeTool: 'Report generated with production-safe {{tool}}, no keys or plaintexts',
  reportGeneratedWithStandardTool: 'Report generated with standard {{tool}}, may contain keys or plaintexts',
  reportIsProducedBy: 'Report is produced by',
  reportName: 'Report name',
  reportPendingMessage: 'Your report is being prepared...',
  reportStatus: {
    done: 'Done',
    failed: 'Failed',
    pending: 'Pending',
    unknown: 'No status',
  },
  reportType: 'Report type',
  reports: 'Reports',
  reportsImpacted: 'Reports impacted',
  reset: 'Reset',
  resetApiKey: {
    cta: 'Reset API Key',
    info: {
      back: 'Cancel',
      content:
        "Resetting your API key invalidates your current key. You'll need to use the new key for future API authentication.<br/>Do you want to continue?",
      submit: 'Yes, reset the API Key',
    },
    success: {
      close: 'Close',
      content: "Copy and securely save the new key before you close this page. For security reasons, this key won't be displayed again.",
    },
    title: 'Reset your personal API key',
  },
  resetFilters: 'Reset filters',
  resetPassword: 'Reset password',
  resetUserPassword: {
    info: {
      back: 'Cancel',
      content:
        'You are about to reset the password for <bold>{{username}}</bold>. This action cannot be undone.<br/><bold>Once the password has been reset, you need to communicate it to the user to enable login.</bold><br/>Do you want to continue?',
      submit: 'Yes, reset the password',
    },
    subtitle: '',
    success: {
      close: 'Close',
      content: 'The password for {{username}} has been reset.<br/><bold>Please copy it and deliver it to {{username}} to enable login.</bold>',
    },
    title: 'Reset password',
  },
  resources: 'Resources',
  resourcesRequired: 'Resources required',
  returnValue: 'Return value',
  rsa: 'RSA',
  rsaPadding: 'RSA padding',
  rule: 'Rule',
  ruleCategories: {
    algorithm: 'Algorithm',
    conflictingKeyRoles: 'Conflicting key roles',
    cryptoUse: 'Use of Crypto',
    hostScan: 'Host scan',
    illegalAttributeModificationAllowed: 'Illegal attribute modification allowed',
    illegalOperationAllowedForKey: 'Illegal operation allowed for key',
    illegalReturnValue: 'Illegal return value',
    incorrectAttributeCalculation: 'Incorrect attribute calculation',
    incorrectDefaultAttributeValue: 'Incorrect default attribute value',
    insecureAttributeModification: 'Insecure attribute modification',
    insecureDefaultValue: 'Insecure default value',
    insecureKeyDerivation: 'Insecure key derivation',
    insecureKeyExport: 'Insecure key export',
    insecureKeyImport: 'Insecure key import',
    invalidAttributeGenerated: 'Invalid attribute generated',
    invalidTemplateAllowed: 'Invalid template allowed',
    keyLength: 'Key length',
    keyManagement: 'Key management',
    keyMaterialExposed: 'Key material exposed',
    unsafeCryptographyPermitted: 'Unsafe cryptography permitted',
  },
  saltForKeyHash: 'Salt for key hash',
  save: 'Save',
  scanDocs: 'Documentation',
  scanEnd: 'Scan End',
  scanPlatforms: {
    linux: 'LINUX',
    windows: 'WINDOWS',
  },
  scanStart: 'Scan Start',
  scanner: 'Scanner',
  scans: 'Scans',
  scansListSubtitle: 'Discover scans across all your integrations',
  selectInstancePlaceholder: {
    subtitle: 'Please choose an instance from the second column to display the corresponding details here.',
    title: 'Select an Instance',
  },
  selectIssuePlaceholder: {
    subtitle: 'Please choose an issue from the first column to display the corresponding details and instances here.',
    title: 'Select an Issue',
  },
  selectProfile: 'Select profile',
  selfSigned: 'Self-signed',
  sensors: 'Sensors',
  sensorsList: {
    application: {
      description: 'Logs cryptographic calls from a running application trace or bytecode scan and formats the information for analysis by AQtive Guard.',
      java: {
        description: 'Logs cryptographic calls made by a Java application running on a JVM.',
        name: 'Java Tracer',
      },
      javaScanner: {
        description: 'Complements the Java Tracer by providing additional cryptographic information about the code at rest.',
        name: 'Java Bytecode Scanner',
      },
      title: 'Application',
    },
    docs: 'Refer to the <docs>AQtive Guard User Guide</docs> for more information about our cryptographic sensors.',
    download: 'Download',
    host: {
      description:
        'Command-line sensor that scans the filesystem or a container image for cryptographic objects and formats the information for analysis by AQtive Guard.',
      linux: {
        description: 'Filesystem scanner for Linux (64 bit).',
        name: 'Linux Scanner',
      },
      title: 'Filesystem',
      windows: {
        description: 'Filesystem scanner for Windows (64 bit).',
        name: 'Windows Scanner',
      },
    },
    learnMore: '<docs>Learn more</docs>',
    network: {
      description: 'Detects and analyzes cryptographic data from network captures.',
      networkAnalyzer: {
        description: 'Identifies the encryption methods used to secure data during network transmission.',
        name: 'Network Analyzer',
      },
      title: 'Network',
    },
    unavailable: {
      description: 'This sensor is not available. Visit our support portal if you have questions or need help.',
    },
    version: 'v{{version}}',
  },
  serialNumber: 'Serial number',
  serviceNow: 'ServiceNow',
  serviceNowExport: {
    reportExportDone: 'Successfully exported {{count}} instances to ServiceNow',
    reportExportFailure: 'Something went wrong: {{error}}\nIf the problem persists, contact support.',
    reportExportGenericError: 'Something went wrong. Please check your ServiceNow configuration and try again.\nIf the problem persists, contact support.',
    reportExportPartial:
      'Successfully exported {{success}} of {{totalCount}} instances to ServiceNow.\n{{failed}} instances could not be exported: {{error}}\nIf the problem persists, contact support.',
    reportExportZero: 'This report has no failed instances to export',
    singleExportSuccess: 'Successfully exported 1 instance to ServiceNow',
    viewExportedRecord: 'View exported record',
  },
  settings: 'Settings',
  severity: {
    label: {
      disabled: 'Disabled',
      filtered: 'Filtered',
      high: 'High',
      low: 'Low',
      medium: 'Medium',
      na: 'N/A',
      noWarning: 'No warning',
      passed: 'Passed',
    },
    severity: 'Severity',
    tag: {
      disabled: 'Disabled',
      filtered: 'Filtered',
      high: 'High',
      low: 'Low',
      medium: 'Med',
      na: 'N/A',
      noWarning: 'No warning',
      passed: 'Passed',
    },
    tooltip: {
      NA: 'Issues that are valid according to the profile but for which no instances were found.',
      disabled: 'Issues that have been disabled in the profile used to generate the report.',
      filtered: 'Issues for which every instance has been filtered. Filters are defined in the project\'s "Exceptions" tab.',
      passed: 'Issues for which every instance passed.',
      priority: 'High, medium and low risk issues.',
      priorityDefinedByProfile: 'High, medium and low risk issues, as defined by {{profileName}} profile.',
    },
  },
  showMoreInstancesDefault: 'Show more instances',
  showMoreInstances_one: 'Show 1 more instance',
  showMoreInstances_other: 'Show {{count}} more instances',
  signIn: 'Sign in',
  signature: 'Signature',
  signatureAlgorithm: 'Signature algorithm',
  size: 'Size',
  slot: 'Slot',
  slotForm: {
    report: {
      description: 'Report description',
      name: 'Report name',
      type: {
        focused: 'Report type',
        input: 'Select report type',
      },
    },
    slot: {
      description: 'Slot description',
      name: 'Slot name',
      type: {
        focused: 'Slot type',
        input: 'Select slot type',
      },
    },
    tags: {
      focused: 'Tags (press the Enter key to add a tag)',
      input: 'Tags',
    },
  },
  slotName: 'Slot name',
  slotSelectionForm: {
    choose: 'Choose a report',
    create: 'Create a new report',
  },
  slots: 'Slots',
  somethingWentWrong: 'Something went wrong, try again in a minute.',
  source: 'Source',
  specificRemediation: 'Specific remediation',
  specificRemediationAdvice: 'Specific remediation advice',
  stackframes: 'Stackframes',
  starredInstances: '<bold>Starred</bold> instances',
  startNewScan: 'Start A New Scan',
  startNewScanHelp: 'Start a new scan with applied filters. For guidance, refer to <docs>AQtive Guard User Guide</docs>.',
  startScan: 'Start A Scan',
  statistics: 'Statistics',
  status: 'Status',
  stop: 'Stop',
  stopped: 'Stopped',
  subject: 'Subject',
  summary: 'Summary',
  summaryOfCryptographyUsage: 'Summary of Cryptography Usage',
  symmetric: 'Symmetric',
  symmetricAlgorithms: 'Symmetric Algorithms',
  tags: 'Tags',
  tanium: 'Tanium',
  term: 'Term',
  timesUsed: 'Times Used',
  timestamp: 'Timestamp',
  tipsAndHints: 'Tips & Hints',
  tlsSessionKey: 'TLS Session key',
  tlsVersion: {
    none: 'None',
    unknown: 'Unknown',
  },
  today: 'Today',
  toggleExceptions: {
    disabled: 'The exception has been disabled. Existing analyses are not affected.',
    enabled: 'The exception has been enabled. Existing analyses are not affected.',
  },
  toggleOperator: 'Change operator to {{operator}}',
  togglePasswordVisibility: {
    hidden: 'Show password',
    visible: 'Hide password',
  },
  toggleVisibility: {
    hidden: 'Show {{ field }}',
    visible: 'Hide {{ field }}',
  },
  total: 'Total',
  trace: 'Trace',
  traceType: {
    dotNet: '.NET Usage',
    evp: 'OpenSSL libcrypto Usage',
    hostScanner: 'Host Scanner',
    java: 'Java Usage',
    label: 'Trace type',
    libssl: 'OpenSSL libssl Usage',
    network: 'Network Capture',
    pkcsFuzzing: 'PKCS#11 Fuzzing',
    pkcsUsage: 'PKCS#11 Usage',
    python: 'Python Usage',
  },
  traceUploadForm: {
    maxReportsWarning:
      'You have reached the maximum number of versions for this report. Generating a new version will automatically delete the oldest version.',
    processing: 'Processing file...',
    restrictions: '.cst, .cst.gz, .gz, .pcap, .pcapng (max. 4GB)',
    retry: 'Retry',
    uploading: 'Uploading file...',
  },
  traceUsed: 'Trace used',
  tracer: 'Tracer',
  traces: 'Traces',
  triage: 'Triage',
  true: 'True',
  type: 'Type',
  unknown: 'Unknown',
  unknownCiphersuite: 'Unknown ciphersuite ({{nid}})',
  unsuccessfulSSOLogin: 'Unsuccessful SSO login, please try again.',
  unusedKeys: 'Unused keys',
  updateProfile: {
    back: 'Cancel',
    name: {
      focused: 'Name',
      input: 'Type the new profile name',
    },
    submit: 'Save',
    title: 'Update profile',
  },
  updateProject: {
    back: 'Cancel',
    submit: 'Save',
    subtitle: '',
    title: 'Edit the details of your project',
  },
  updateSlot: {
    back: 'Cancel',
    submit: 'Save',
    subtitle: '',
    title: 'Edit the details of your slot',
  },
  updateUser: {
    back: 'Cancel',
    disclaimers: {
      permissionDowngrade: 'Changing the permission level to {{level}} will partially revoke existing capabilities',
      permissionUpdateDisabled: 'Not enough rights to update the permission level of this user',
      permissionUpgrade: 'Changing the permission level to {{level}} will grant additional capabilities',
      preferredNameUpdateDisabled: 'Not enough rights to update the preferred name of this user',
      rolesChanged: 'Changing the roles of the user will alter its existing capabilities',
      rolesUpdateDisabled: 'Not enough rights to update the roles of this user',
      selfPermissionUpdateDisabled: 'You cannot update your permission level. Contact your administrator.',
      selfPreferredNameUpdateDisabled: 'You cannot update your preferred name. Contact your administrator.',
      selfRolesUpdateDisabled: 'You cannot update your own roles. Contact your administrator',
    },
    submit: 'Save',
    subtitle: '',
    success: 'User {{username}} has been updated',
    title: 'Update user',
  },
  updateUserForm: {
    level: 'Permission level',
    preferredName: {
      focused: 'Preferred name',
      input: 'Enter the new preferred name of the user',
    },
    roles: {
      focused: 'Roles',
      input: 'Enter the new roles of the user',
    },
  },
  uploadTrace: {
    selectSlot: {
      back: 'Cancel',
      create: 'Create report',
      select: 'Continue',
      subtitle: 'Select or create a new report that you would like to upload the trace to.',
      title: 'Analyze a trace',
    },
    slotCreated: {
      submit: 'Continue',
      subtitle: 'You can now upload your trace for analysis.',
      title: 'Your report {{slotName}} has been created',
    },
    upload: {
      subtitle: 'Upload a trace to automatically start its analysis, make sure it matches the slot type or the analysis will fail.',
      title: 'Analyze a trace',
    },
    uploadDone: {
      back: "I'm done",
      submit: 'See report',
      subtitle: 'We are currently processing your trace. We will let you know once the report is complete.',
      title: 'Your report {{reportName}} has been created',
    },
  },
  uploadTraceButton: 'Upload trace',
  usage: 'Usage',
  usageSummary: 'Usage summary',
  useConditionsStatement: {
    text1: 'AQtive Guard screen text and Knowledge Base documents are based on guidance from the cited recognized standards and industry sources.',
    text2: 'However, cybersecurity risk management differs significantly across organizations due to unique threats, vulnerabilities, and risk tolerances.',
    text3:
      'You are responsible for consulting your own security, compliance, and legal advisors to assess the applicability of any observations, insights, and/or results obtained through the use of AQtive Guard for your organization, as well as determining appropriate implementation and responses in accordance with internal policies, industry practices, and regulatory requirements.',
    title: 'Use Conditions Statement',
  },
  used: 'Used',
  usedKeys: 'Used keys',
  userLevels: {
    admin: 'Administrator',
    analyst: 'Analyst',
    description: 'Permission level',
    tester: 'Tester',
  },
  userOrigins: {
    description: 'Account type',
    local: 'Local',
    openId: 'OpenID',
    webAccount: 'Web Account',
  },
  userRoles: {
    admin: 'Administrator',
    analyst: 'Analyst',
    authAdmin: 'Authorization administrator',
    description: 'Roles',
    uploader: 'Uploader',
    viewer: 'Viewer',
  },
  username: 'Username',
  usernameOrEmail: 'Username or email',
  users: 'Users',
  usersListSubtitle: 'Manage the users within your organization.',
  validators: {
    existential: {
      blank: 'The value should be empty',
      required: 'The value is required',
    },
    operational: {
      compare: {
        eq: 'The value should be equal to {{value}}',
        gt: 'The value should be greater than {{value}}',
        gte: 'The value should be greater or equal than {{value}}',
        invalid: 'The value is not comparable',
        lt: 'The value should be less than {{value}}',
        lte: 'The value should be less or equal than {{value}}',
        neq: 'The value should not be equal to {{value}}',
      },
      file: {
        ext: 'File type should be one of {{extensions}}',
        maxSize: 'File size should be smaller than {{maxSize}} {{unit}}',
      },
      length: {
        equals: 'The value should be exactly {{length}} characters long',
        max: 'The value should be at most {{length}} characters long',
        min: 'The value should be at least {{length}} characters long',
        noParam: 'The value has no length',
      },
    },
    type: {
      number: 'The value should be a number',
      portNumber: 'The value should be a port number (0 to 65535)',
      regex: 'The value does not match the required format',
      url: 'The value is not a valid url',
    },
    url: {
      trailingSlash: 'The url must not contain trailing "/"',
    },
  },
  validities: {
    EXPIRED: 'Expired',
    EXPIRING_SOON: 'Expiring soon',
    NOT_VALID_YET: 'Not valid yet',
    VALID: 'Valid',
  },
  validity: 'Validity',
  validityLength: 'Validity length',
  validityLengths: {
    '2_TO_5_YEARS': '2 to 5 years',
    '5_TO_10_YEARS': '5 to 10 years',
    LESS_THAN_2_YEARS: 'Less than 2 years',
    MORE_THAN_10_YEARS: 'More than 10 years',
  },
  value: 'Value',
  venafi: 'Venafi',
  venafiDetails: 'Venafi details',
  venafiGuid: 'Venafi GUID',
  venafiLastUpdated: 'Last updated: {{ date }}',
  venafiLink: 'Venafi URL',
  venafiPopulateGuids: 'Populate Venafi GUIDs',
  venafiPopulateSuccess: 'Venafi GUIDs populated successfully',
  venafiUpdateGuids: 'Update Venafi GUIDs',
  venafiUpdateSuccess: 'Venafi GUIDs updated successfully',
  venafiUpload: 'Upload to Venafi',
  venafiUploadPolicy: 'Policy DN',
  venafiUploadPolicyHelp: 'The Distinguished Name (DN) of the folder that will hold the certificate',
  version: 'Version',
  versionDate: 'Version date',
  versionName: 'Version name',
  versions: 'Versions',
  viewException: 'View exception',
  viewJiraIssue: 'View Jira issue',
  vmdk: 'VMDK',
  welcome: 'Welcome to AQtive Guard',
  withExceptions: 'With exceptions',
  withoutExceptions: 'Without exceptions',
  wrappedByKey: 'Wrapped by key',
  wrappedKey: 'Wrapped key',
  yes: 'Yes',
  you: 'You',
};
